import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {GenericActionComponent, GenericActionComponentsMethods} from "../generic-action.component";
import {CommonUtils} from "../../utils/common";
import {FormBuilder, Validators} from "@angular/forms";
import {AppStateService} from "../../providers/app-state.service";
import {ModalController, ToastController} from "@ionic/angular";
import {TranslateService} from "@ngx-translate/core";
import {PartnerService} from "../../providers/partner.service";
import {Partner} from "../../models/partner.model";
import {VImage} from "../../models/vet-clinic.model";
import {Subscription} from "rxjs";
import {FileService} from "../../providers/file.service";
import {VImageDropComponent} from "../v-image-drop/v-image-drop.component";

@Component({
  selector: 'app-edit-partner',
  templateUrl: './edit-partner.component.html',
  styleUrls: ['./edit-partner.component.scss'],
})
export class EditPartnerComponent extends GenericActionComponent implements OnInit, OnDestroy, GenericActionComponentsMethods {

  @Input() partner: Partner;
  @Input() csrfToken: string;

  @Output() objectEditedEmitter = new EventEmitter<Partner>();
  @Output() objectAddedEmitter = new EventEmitter<Partner>();
  @Output() hasUnsavedChangesEmitter = new EventEmitter<boolean>();

  private vImages: VImage[];
  private vImagesSub: Subscription;
  pc: Partner;
  isArticleModeEnabled: boolean = false;
  isNipGlobalValidationNecessary: boolean = false;
  partnerBannerActions: boolean;


  constructor(
    public commonUtils : CommonUtils,
    private formBuilder: FormBuilder,
    private partnerService: PartnerService,
    private appStateService: AppStateService,
    private toastController: ToastController,
    private modalController: ModalController,
    private translateService: TranslateService,
    private fileService: FileService
  ) {
    super(commonUtils, appStateService, modalController, translateService);
  }

  ngOnInit() {
    this.pc = JSON.parse(JSON.stringify(this.partner));
    if (this.action === 'ADD') {
      this.componentTitle = 'Dodaj nowego partnera';
      this.actionBtnLabel = 'Dodaj partnera';
      this.actionQuestion = 'Na pewno chcesz dodać partnera?';
      this.actionSuccess = 'Partner został dodany';
      this.actionError = 'Wystąpił błąd podczas dodawania partnera'
      this.formGroup = this.formBuilder.group({
        name: ['', Validators.required],
        appPartnerPageTitle: ['', Validators.required],
        appPartnerPageSlogan: ['', Validators.required],
        appPartnerPageContent: ['', Validators.required],
        termsOfServicePageContent: ['', Validators.required],
        technicalSupport: ['', Validators.required]
      });
    } else {
    this.createEditForm()
    }

    if (this.partner?.uuid) {
      this.vImagesSub = this.fileService.getPartnerVImages(this.partner.uuid).subscribe(images => {
        this.vImages = images;
      });
    } else {
      this.vImages = [];
    }

    this.isBusySub = this.appStateService.isBusySubject.subscribe(isBusy => {
      this.isBusy = isBusy;
    });

    super.ngOnInit();
  }

   createEditForm() {
    this.componentTitle = 'Zmień partnera';
    this.actionBtnLabel = 'Zmień partnera';
    this.actionQuestion = 'Na pewno chcesz zmienić partnera?';
    this.actionSuccess = 'Partner został zmieniony';
    this.actionError = 'Wystąpił błąd podczas zmiany partnera';
    this.formGroup = this.formBuilder.group({
      name: [this.partner.name, Validators.required],
      appPartnerPageTitle: [this.partner.appPartnerPageTitle, Validators.required],
      appPartnerPageSlogan: [this.partner.appPartnerPageSlogan, Validators.required],
      appPartnerPageContent: [this.partner.appPartnerPageContent, Validators.required],
      termsOfServicePageContent: [this.partner.termsOfServicePageContent, Validators.required],
      technicalSupport: [this.partner.technicalSupport, Validators.required],
      splashScreenImageUUID: [this.partner.splashScreenImageUUID],
      logoImageUUID: [this.partner.logoImageUUID],
      partnerPageImageUUID: [this.partner.partnerPageImageUUID],
      banner1Page: [this.partner.banner1Page],
      banner1Placeholder: [this.partner.banner1Placeholder],
      banner1ImageUUID: [this.partner.banner1ImageUUID],
      banner2Page: [this.partner.banner2Page],
      banner2Placeholder: [this.partner.banner2Placeholder],
      banner2ImageUUID: [this.partner.banner2ImageUUID],
      banner3Page: [this.partner.banner3Page],
      banner3Placeholder: [this.partner.banner3Placeholder],
      banner3ImageUUID: [this.partner.banner3ImageUUID],
      successActionBannerImageUUID: [this.partner.successActionBannerImageUUID],
      additionalImage1ImageUUID: [this.partner.additionalImage1ImageUUID],
      additionalImage2ImageUUID: [this.partner.additionalImage2ImageUUID],
      additionalImage3ImageUUID: [this.partner.additionalImage3ImageUUID],
      additionalImage4ImageUUID: [this.partner.additionalImage4ImageUUID],

    });
    this.isNipGlobalValidationNecessary = this.partner.isNipGlobalValidationNecessary;
    this.isArticleModeEnabled = this.partner.isArticleModeEnabled;
    this.partnerBannerActions = this.partner.partnerBannerActions;
  }

  onAction() {
    this.commonUtils.presentYesNoActionSheet('Na pewno chcesz zapisać zmiany?', 'Tak', 'Nie', 'checkmark', 'close', () => {
      let partnerObj: Partner = this.commonUtils.formGroupValuesToObject<Partner>(new Partner(), this.formGroup);

      console.log(partnerObj);
      partnerObj.type = 'PARTNER';

      partnerObj.isArticleModeEnabled = this.isArticleModeEnabled;

      if (this.action === 'EDIT') {
        partnerObj.id = this.partner.id;
        partnerObj.uuid = this.partner.uuid;
        if (this.images) {
          partnerObj.vImagesToSetAsActive = this.images.map(e => e.uuid)
        }
        partnerObj.isNipGlobalValidationNecessary = this.isNipGlobalValidationNecessary;
        partnerObj.partnerBannerActions = this.partnerBannerActions;

        this.partnerService.updatePartner(partnerObj).subscribe(e => {
          if (e) {
            this.objectEditedEmitter.emit(e);
          }
        });
      } else {
        this.partnerService.addPartner(partnerObj).subscribe(e => {
          if (e) {
            this.commonUtils.presentInfoToast("Partner został dodany, uzupełni pozostałe informacje");
            this.partner = e;
            this.action = 'EDIT'
            this.createEditForm()
          }
        });
      }
    }, () => {
    });
  }

  async openImageDropForPhoto(formControlName: 'splashScreenImageUUID' |
                                'successActionBannerImageUUID' |
                                'partnerPageImageUUID' |
                                'logoImageUUID' |
                                'banner1ImageUUID' |
                                'banner2ImageUUID' |
                                'banner3ImageUUID' |
                                'additionalImage1ImageUUID' |
                                'additionalImage2ImageUUID' |
                                'additionalImage3ImageUUID' |
                                'additionalImage4ImageUUID'
    , imageFolder: string) {

    const modal = await this.modalController.create({
      component: VImageDropComponent,
      componentProps: {
        'multiple': false,
        'vClientUUID': this.partner.uuid,
        'imageFolder': imageFolder
      }
    });

    modal.onDidDismiss<VImage>().then((dismissData) => {
      if (dismissData && dismissData.data !== null) {
        console.log(dismissData);
        this.markUnsavedChanges();
        if (formControlName === 'splashScreenImageUUID') {
          this.partner.splashScreenImage = dismissData.data;
          this.partner.splashScreenImageUUID = dismissData.data.uuid;
        } else if (formControlName === 'logoImageUUID') {
          this.partner.logoImage = dismissData.data;
          this.partner.logoImageUUID = dismissData.data.uuid;
        } else if (formControlName === 'banner1ImageUUID') {
          this.partner.banner1Image = dismissData.data;
          this.partner.banner1ImageUUID = dismissData.data.uuid;
        } else if (formControlName === 'banner2ImageUUID') {
          this.partner.banner2Image = dismissData.data;
          this.partner.banner2ImageUUID = dismissData.data.uuid;
        } else if (formControlName === 'banner3ImageUUID') {
          this.partner.banner3Image = dismissData.data;
          this.partner.banner3ImageUUID = dismissData.data.uuid;
        } else if (formControlName === 'successActionBannerImageUUID') {
          this.partner.successActionBannerImage = dismissData.data;
          this.partner.successActionBannerImageUUID = dismissData.data.uuid;
        } else if (formControlName === 'partnerPageImageUUID') {
          this.partner.partnerPageImage = dismissData.data;
          this.partner.partnerPageImageUUID = dismissData.data.uuid;
        } else if (formControlName === 'additionalImage1ImageUUID') {
          this.partner.additionalImage1Image = dismissData.data;
          this.partner.additionalImage1ImageUUID = dismissData.data.uuid;
        } else if (formControlName === 'additionalImage2ImageUUID') {
          this.partner.additionalImage2Image = dismissData.data;
          this.partner.additionalImage2ImageUUID = dismissData.data.uuid;
        } else if (formControlName === 'additionalImage3ImageUUID') {
          this.partner.additionalImage3Image = dismissData.data;
          this.partner.additionalImage3ImageUUID = dismissData.data.uuid;
        } else if (formControlName === 'additionalImage4ImageUUID') {
          this.partner.additionalImage4Image = dismissData.data;
          this.partner.additionalImage4ImageUUID = dismissData.data.uuid;
        }
        if (this.images) {
          this.images.push(dismissData.data)
        } else {
          this.images = [];
          this.images.push(dismissData.data)
        }
        this.formGroup.get(formControlName).setValue(dismissData.data?.uuid);
        this.hasUnsavedChanges = true;
      }
    });

    return await modal.present();
  }

  ngOnDestroy() {
    if (this.vImagesSub) {
      this.vImagesSub.unsubscribe();
    }
    if (this.isBusySub) {
      this.isBusySub.unsubscribe();
    }
  }

  revertImage(valueToRevert: string, image: VImage) {
    if (valueToRevert === 'splashScreenImage') {
      this.partner.splashScreenImage = this.pc.splashScreenImage;
      this.partner.splashScreenImageUUID = this.pc.splashScreenImageUUID;
    } else if (valueToRevert === 'logoImage') {
      this.partner.logoImage = this.pc.logoImage;
      this.partner.logoImageUUID = this.pc.logoImageUUID;
    } else if (valueToRevert === 'banner1Image') {
      this.partner.banner1Image = this.pc.banner1Image;
      this.partner.banner1ImageUUID = this.pc.banner1ImageUUID;
    } else if (valueToRevert === 'banner2Image') {
      this.partner.banner2Image = this.pc.banner2Image;
      this.partner.banner2ImageUUID = this.pc.banner2ImageUUID;
    } else if (valueToRevert === 'banner3Image') {
      this.partner.banner3Image = this.pc.banner3Image;
      this.partner.banner3ImageUUID = this.pc.banner3ImageUUID;
    } else if (valueToRevert === 'successActionBannerImage') {
      this.partner.successActionBannerImage = this.pc.successActionBannerImage;
      this.partner.successActionBannerImageUUID = this.pc.successActionBannerImageUUID;
    } else if (valueToRevert === 'partnerPageImage') {
      this.partner.partnerPageImage = this.pc.partnerPageImage;
      this.partner.partnerPageImageUUID = this.pc.partnerPageImageUUID;
    } else if (valueToRevert === 'additionalImage1Image') {
      this.partner.additionalImage1Image = this.pc.additionalImage1Image;
      this.partner.additionalImage1ImageUUID = this.pc.additionalImage1ImageUUID;
    } else if (valueToRevert === 'additionalImage2Image') {
      this.partner.additionalImage2Image = this.pc.additionalImage2Image;
      this.partner.additionalImage2ImageUUID = this.pc.additionalImage2ImageUUID;
    } else if (valueToRevert === 'additionalImage3Image') {
      this.partner.additionalImage3Image = this.pc.additionalImage3Image;
      this.partner.additionalImage3ImageUUID = this.pc.additionalImage3ImageUUID;
    } else if (valueToRevert === 'additionalImage4Image') {
      this.partner.additionalImage4Image = this.pc.additionalImage4Image;
      this.partner.additionalImage4ImageUUID = this.pc.additionalImage4ImageUUID;
    }

    if (this.images) {
      this.images = this.images.filter(e => e.uuid !== image.uuid);
    }
  }
  override markUnsavedChanges() {
    if(!this.hasUnsavedChanges) {
      this.hasUnsavedChangesEmitter.emit(true);
    }
    super.markUnsavedChanges();
  }

}

